module.exports = __webpack_public_path__ + "jhu_logo_2026-3cbc0342c45e3d163a7a8ef4cde8421d.png";